export const PASTE_LIMIT = 30;

const DELIMITERS = /[\s,;|]+/;
const WRAPPERS = /^[<"'[(]+|[>"'\])]+$/g;
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function tokenize(text: string): string[] {
  return (text ?? "")
    .split(DELIMITERS)
    .map((token) => token.replace(WRAPPERS, "").trim())
    .filter((token) => token.length > 0);
}

export function parsePastedEmails(text: string): string[] {
  const emails = tokenize(text)
    .map((token) => token.toLowerCase())
    .filter((token) => EMAIL_RE.test(token));

  return Array.from(new Set(emails));
}

export function parsePastedSkuCodes(text: string): string[] {
  const seen = new Set<string>();

  return tokenize(text)
    .filter((token) => !token.includes("@"))
    .filter((code) => {
      const key = code.toLowerCase();
      if (seen.has(key)) {
        return false;
      }
      seen.add(key);
      return true;
    });
}
